import React, { useEffect, useState, Fragment } from 'react';
import axios from '../../axios-instance';
import { useSelector } from 'react-redux';
import { withCookies, useCookies } from 'react-cookie';
import Stats from '../Stats/Stats';
import Question from '../Question/Question';
import Logo from '../UI/Logo/Logo';
import Button from '../UI/Button/Button';
import classes from '../Sweepstake/Sweepstake.module.scss';
import Banner from '../Banner/Banner';
import { updateContentStatus, postEvent, getCdnPath } from '../../utils/helpers';
import thanksARamaGiveAway from '../../images/30k-thanks-a-rama-giveaway.png';
import twolAhgHeroImage from '../../images/at-home-game-25wol-hero.jpg';
import pictAhgHeroImage from '../../images/at-home-game-pictionary-hero.jpg';
import ppotAhgHeroImage from '../../images/at-home-game-ppot-hero.jpg';
import BehindTheScenes from '../BehindTheScenes/BehindTheScenes';

const Sweepstake = (props) => {
    const [cookies,
        setCookie,
        // removeCookie
    ] = useCookies(['A8FPVID', 'A8CFVLH', 'A8USRID', 'A8USRTKN', 'A8TKTCTR', 'A8STATS', 'A8PROFDT', 'A8PRESUBD']); 
    const [question, setQuestion] = useState(null);

    const [showLandingPage, setShowLandingPage] = useState(true);
    const [showQuestion, setShowQuestion] = useState(false);
    const [answerId, setAnswerId] = useState(null);
    const [showSubmissionForm, setShowSubmissionForm] = useState(false);
    const [formValidationError, setFormValidationError] = useState(null);
    const [firstName, setFirstName] = useState(cookies?.A8PROFDT?.first_name);
    const [lastName, setLastName] = useState(cookies?.A8PROFDT?.last_name);
    const [emailAddress, setEmailAddress] = useState(cookies?.A8PROFDT?.email);
    const [phoneNumber, setPhoneNumber] = useState(cookies?.A8PROFDT?.phone_number);
    const [rememberMe, setRememberMe] = useState(cookies?.A8PRESUBD? cookies.A8PRESUBD === 'true' : false);
    const [dataPrivacyOptedIn, setDataPrivacyOptedIn] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showLoserMessage, setShowLoserMessage] = useState(false);
    const [heroImage, setHeroImage] = useState(null);
    const content = useSelector((state) => state.content);    
    const device = useSelector((state) => state.device);
    const user = (cookies.A8USRID && cookies.A8USRTKN) && {id:cookies.A8USRID, token:cookies.A8USRTKN}

    const [stats, setStats] = useState(cookies.A8STATS?? {
        played : 0,
        correct : 0,
        streak : 0,
        max : 0
    });

    const createMarkup = (richText) => {
        return {__html : richText}
    }

    const landingPage = {
        display : true,
        title : "At Home",
        subtitle : "Game",
        cta : {
            label : "Tap To Start"
        }
    };

    const requestQuestion = () => { 
        axios.get(
            `/sweepstake/${props.content.deliverable.id}/question/${props.content.deliverable.question_ids[0]}?trigger_uuid=${props.triggerUuid}`, {headers: {
                'x-device-uuid': `${device?.deviceDetails?.uuid}`,
                'Authorization' : 'Bearer ' + cookies.A8USRTKN
              }}
        ).then((res)=>{
            if (res && res.data) {
                setQuestion(res.data);
                setShowQuestion(true);
            } else {

            }
        }).catch((err)=>{

        }).finally();

        setShowLandingPage(false);

    }

    const handleAnswerConfirmation = (answer_id, correct) => {
        
        let currentStats = stats;
        currentStats.played++;

        if(correct === true) {            
            currentStats.correct++;
            currentStats.streak++;
            if(currentStats.streak > currentStats.max ) {
                currentStats.max = currentStats.streak;
            }
            setAnswerId(answer_id);
            setShowQuestion(false);
            setShowSubmissionForm(true);
            setShowLoserMessage(false);
        } else {
            console.log(correct);
            currentStats.streak = 0;
            setShowQuestion(false);
            setShowLoserMessage(true);
        }

        if(cookies.A8USRTKN) {
            let payload = currentStats;
            payload.content_id = props.content.pivot?.content_id;
            payload.client_id = props.content.client_id;
            payload.campaign_id = props.content.pivot?.campaign_id;
            payload.trigger_id = props.content.pivot?.trigger_id;

            axios.post('user/score', payload, {
                headers: {
                    'x-device-uuid': `${device?.deviceDetails?.uuid}`,
                    'Authorization' : 'Bearer ' + cookies.A8USRTKN
                }}
            ).then((res) => {
                console.log(res)
                if(res && res.status === 200) {
                    console.log('setting stats cookie')
                    setCookie('A8STATS', currentStats, {
                        maxAge: 3600 * 24 * 30,
                        path: '/',
                        domain: process.env.REACT_APP_COOKIE_DOMAIN
                    });                    
                }

            }).catch().finally();
        } else {
            setStats(currentStats);
            setCookie('A8STATS', currentStats, {
                maxAge: 3600 * 24 * 30,
                path: '/',
                domain: process.env.REACT_APP_COOKIE_DOMAIN
            });
        }


    }

    const validateFormFields = (field) => {
        let validRegex; 
        let errorMessage;
        
        if(field === 'email') {
            if(!emailAddress) {
                return;
            }

            validRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

            if(!emailAddress.match(validRegex)) {
                errorMessage = 'Please enter a valid email address';
            }
        } else if (field === 'phone') {
            if(!phoneNumber) {
                return;
            }
            validRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
            if(!phoneNumber.match(validRegex)) {
                errorMessage = 'Please enter a valid phone number';
            }
        } 

        setFormValidationError(errorMessage)
    }

    const enterSweepstake = () => {
        const payload = {
            first_name : firstName,
            last_name : lastName,
            email : emailAddress,
            phone_number : phoneNumber,
            source_type : 'question_answer',
            source_id : answerId,
        }
        axios.post(
            `/user/subscribe`, payload, {headers: {
                'x-device-uuid': `${device?.deviceDetails?.uuid}`,
                'Authorization' : 'Bearer ' + cookies.A8USRTKN
              }}
        ).then((res)=>{
            if (res && res.data) {
                console.log(res.data);
                setShowSubmissionForm(false);
                setShowConfirmation(true);
                if(rememberMe) {
                    setCookie('A8PRESUBD', rememberMe, 
                    {
                        maxAge : 3600 * 24 * 365,
                        path: "/",
                        domain: process.env.REACT_APP_COOKIE_DOMAIN
                    })
                    console.log('Stored prefill preference');
                }
                // setShowSponsorBanner(false);
                // Post event
                postEvent(device.deviceDetails, {
                    category: "end-user-action",
                    subcategory: "sweepstakes",
                    action: "submit-contact-information",
                    label: question.name,
                    content_id : props.content.pivot?.content_id,
                    client_id : props.content.client_id,
                    campaign_id : props.content.pivot?.campaign_id,
                    trigger_id : props.content.pivot?.trigger_id
                }, user);
            } else {

            }
        }).catch((err)=>{

        }).finally();
    }


    const landingPageContainer = 
        <div>
            <div><img src={heroImage} style={{width: "100%", paddingTop: "20px"}} alt='Hero img'/></div>
            {/* <h1 style={{
                width: "100%",
                color: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_FONT_SIZE,
                fontWeight: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_FONT_WEIGHT,
                textTransform: "uppercase",
                lineHeight: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_LINE_WEIGHT,
                textAlign: "center",
                paddingTop: "20px",
                paddingBottom: "0px",
                margin: "0px",
                textShadow : process.env.REACT_APP_CONTENT_STYLE_TITLE_TEXT_SHADOW
            }}>{landingPage.title}</h1>
            <h2 style={{
                fontStyle: "italic",
                width: "100%",
                color: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_COLOR,
                fontFamily: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_FONT_SIZE,
                fontWeight: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_FONT_WEIGHT,
                lineHeight: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_LINE_WEIGHT,
                textAlign: "center",
                padding: "0px",
                margin: "0px"
            }}>{landingPage.subtitle}</h2> */}
            <div style={{
                marginTop:"28px", 
                // borderTop: "#CCC 1px solid", 
                width: "89%", 
                marginLeft: "auto", 
                marginRight: "auto", 
                fontWeight: "500", 
                textAlign: "center",
                lineHeight: "24px",
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
                fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR
            }}>
                <div dangerouslySetInnerHTML={createMarkup(process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_DESCRIPTION)}></div>
            </div>
            <div style={{width:"88%", marginLeft:"auto", marginRight: "auto", paddingBottom: "20px"}}>
                <Button 
                    style={{
                        fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                        fontSize: process.env.REACT_APP_BUTTON_FONT_SIZE,
                        fontWeight: "800",
                        letterSpacing: 0.5,
                        lineHeight: "21px",
                        textTransform: "uppercase",
                        color: process.env.REACT_APP_BUTTON_COLOR,
                        marginTop: "20px",
                        height: "50px",
                        borderRadius: process.env.REACT_APP_BUTTON_BORDER_RADIUS,
                        backgroundColor: process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND_COLOR,
                        background: process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND,
                        boxShadow: process.env.REACT_APP_BUTTON_SHADOW,
                        //borderColor: "transparent",
                        border: process.env.REACT_APP_BUTTON_DEFAULT_BORDER,
                    }}
                    onClick={requestQuestion} 
                    className={classes.Button}                     
                    btnText={landingPage.cta.label}/>                        
            </div>
        </div>

    const questionContainer = <Question question={question} callback={(answer_id, correct) => {handleAnswerConfirmation(answer_id,correct)}}/>

    const submissionFormContainer = 
        <div> 
            <h1 style={{
                color: process.env.REACT_APP_CONTENT_STYLE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_SIZE,
                fontWeight: "600",
                textTransform: "uppercase",
                lineHeight: "28px",
                textAlign: "center",
                paddingTop: "20px"
            }}>CONGRATS!</h1>
            <div style={{
                borderTop: "#CCC 1px solid",
                width: "85%",
                margin: "0px auto 0px auto",
                textAlign: "left",
                fontWeight : "500",
                lineHeight : "24px",
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
                fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR
            }}>
                <div dangerouslySetInnerHTML={createMarkup(process.env.REACT_APP_SWEEPSTAKES_CONGRATULATIONS_MESSAGE)}></div>
                <form style={{fontFamily: process.env.REACT_APP_BODY_STYLE_FONT_FAMILY, fontWeight: "600"}} onSubmit={(event)=>{
                    event.preventDefault();
                    console.log('Entry submission');
                    enterSweepstake();
                    }}>
                    {/* <label htmlFor="first_name" style={{fontSize: "12px", fontWeight: "500", color: "#4C4C4C", marginTop: "10px"}}>First Name</label> */}
                    <input required id="first_name" placeholder="First Name" defaultValue={cookies?.A8PROFDT?.first_name} type="text" style={{width: "96%", paddingLeft: "3%", height: "40px", marginBottom: "20px", borderRadius: "6px", borderColor: "#B0B0B0", borderStyle: "solid", borderWidth: "1px"}} onChange={(event) => {setFirstName(event.target.value)}} /><br/>
                    {/* <label htmlFor="last_name" style={{fontSize: "12px", fontWeight: "500", color: "#4C4C4C", marginTop: "10px"}}>Last Name</label> */}
                    <input required id="last_name" placeholder="Last Name" defaultValue={cookies?.A8PROFDT?.last_name} type="text" style={{width: "96%", paddingLeft: "3%", height: "40px", marginBottom: "20px", borderRadius: "6px", borderColor: "#B0B0B0", borderStyle: "solid", borderWidth: "1px"}}  onChange={(event) => {setLastName(event.target.value)}}/><br/>
                    {/* <label htmlFor="email_address" style={{fontSize: "12px", fontWeight: "500", color: "#4C4C4C", marginTop: "10px"}}>Email Address</label> */}
                    <input required id="email_address" placeholder="Email" defaultValue={cookies?.A8PROFDT?.email} type="email" style={{width: "96%", paddingLeft: "3%", height: "40px", marginBottom: "20px", borderRadius: "6px", borderColor: "#B0B0B0", borderStyle: "solid", borderWidth: "1px"}}  onChange={(event) => {setEmailAddress(event.target.value); }} onBlur={() => validateFormFields('email')}/><br/>
                    {/* <label htmlFor="phone_number" style={{fontSize: "12px", fontWeight: "500", color: "#4C4C4C", marginTop: "10px"}}>Phone Number</label> */}
                    <input required id="phone_number" type="text" defaultValue={cookies?.A8PROFDT?.phone_number} disabled={cookies?.A8PROFDT?.phone_number} placeholder='Phone Number (i.e. "555-555-5555")' style={{width: "96%", paddingLeft: "2%", height: "40px", marginBottom: "px", borderRadius: "4px", borderColor: "#B0B0B0", borderStyle: "solid", borderWidth: "1px"}}  onChange={(event) => {setPhoneNumber(event.target.value); }} onBlur={() => validateFormFields('phone')} /><br/>
                    {cookies?.A8PROFDT?.phone_number && <p style={{fontSize: "12px", color: "#B0B0B0", textAlign: "center", marginTop: "0px"}}>Phone number saved in profile</p>}
                    <p style={{color: "red", marginTop: "5px"}}>{formValidationError}</p>
                    <div style={{marginTop: "17px", display:"flex"}}>
                        <div style={{paddingRight: "7px"}}>
                            <input id="data_remember_me" type="checkbox" defaultChecked={rememberMe} style={{border: "#979797", width: "17px", height: "17px"}} onClick={(event) => {console.log(event.target.checked); setRememberMe(event.target.checked); }}/>
                        </div>                    
                        <div style={{fontFamily: process.env.REACT_APP_BODY_STYLE_FONT_FAMILY, fontSize: "14px", fontWeight: "500", color: "#565656"}}>
                            Remember my submission info
                        </div>     
                    </div>

                    <div style={{marginTop: "10px", display:"flex"}}>
                        <div style={{height: "80px", paddingRight: "7px"}}>
                            <input required id="data_privacy_opted_in" type="checkbox" style={{border: "#979797", width: "17px", height: "17px"}} onClick={(event) => {console.log(event.target.checked); setDataPrivacyOptedIn(event.target.checked); }}/>
                        </div>                    
                        <div style={{fontFamily: process.env.REACT_APP_BODY_STYLE_FONT_FAMILY, fontSize: "14px", fontWeight: "500", color: "#565656"}}>
                            I agree to the&nbsp; 
                            <a href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target="_blank" rel="noreferrer">Terms of service</a>,&nbsp;
                            <a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">Privacy Policy</a>,&nbsp;and&nbsp;
                            <a href={process.env.REACT_APP_SWEEPSTAKES_RULES_URL} target="_blank" rel="noreferrer">Sweepstakes Rules</a><br/>
                        </div>     
                    </div>

                    <div style={{width:"100%", marginLeft:"auto", marginRight: "auto", paddingBottom: "20px"}}>
                        <Button 
                        style={{
                                // fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                                // fontSize: "18px",
                                // fontWeight: "800",
                                // letterSpacing: 0.5,
                                // lineHeight: "21px",
                                // textTransform: "uppercase",
                                // color: "white",
                                // marginTop: "0px",
                                // height: "50px",
                                // borderRadius: "10px",
                                // background: (firstName && lastName && emailAddress && dataPrivacyOptedIn && cookies?.A8PROFDT?.phone_number) ? process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND : "#8A8A8A",
                                background: process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND,
                                // boxShadow: process.env.REACT_APP_BUTTON_DEFAULT_SHADOW,
                                // borderColor: "transparent" 
                            }} 
                            onClick={(event)=>{
                                console.log('Clicked submission button');
                                }} btnText={'Submit'}/>
                    </div>
                </form>
            </div>
        </div>;        

    const statsModule = <Stats enableShare={true} data={stats} content={props.content} device={device.deviceDetails}/>

    const confirmationContainer = 
        <div> 
            <h1 style={{
                color: process.env.REACT_APP_CONTENT_STYLE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_SIZE,
                fontWeight: "600",
                textTransform: "uppercase",
                lineHeight: "28px",
                textAlign: "center",
                paddingTop: "20px"
            }}>Submitted</h1>
            <div style={{
                borderTop: "#CCC 1px solid",
                width: "85%",
                margin: "0px auto 0px auto",
                textAlign: "center",
                fontWeight : "500",
                lineHeight : "24px",
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
                fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR
            }}>
                {/* <div dangerouslySetInnerHTML={createMarkup(process.env.REACT_APP_SWEEPSTAKES_CONFIRMATION_MESSAGE)}></div> */}

                <p>Thanks for playing today’s <br/><strong>{process.env.REACT_APP_NAME} At-Home Game!</strong> </p><p>We've received your entry for today's game. If you are selected as a winner, we will contact you via the email address or phone number provided. Good luck!</p>
            </div>            
        </div>;                


    const nextContentButton =
        <div>
        {(process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_COLOR && 
                process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_BACKGROUND && 
                process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_SHADOW) ?  
            <Button style={{
                fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                fontSize: "18px",
                fontWeight: "800",
                letterSpacing: 0.5,
                lineHeight: "21px",
                textTransform: "uppercase",
                color: process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_COLOR,
                marginTop: "20px",
                height: "50px",
                borderRadius: process.env.REACT_APP_BUTTON_BORDER_RADIUS,
                background: process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_BACKGROUND,
                boxShadow: process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_SHADOW,
                border: process.env.REACT_APP_BUTTON_TRANSPARENT,
                marginBottom: "20px"
            }} onClick={props.moveToNextContent} btnText={process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_LABEL?? "Tap Here"}/> : 
            <Button style={{
                fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                fontSize: "18px",
                fontWeight: "800",
                letterSpacing: 0.5,
                lineHeight: "21px",
                textTransform: "uppercase",
                color: process.env.REACT_APP_NAME_FONT_COLOR,
                marginTop: "20px",
                height: "50px",
                borderRadius: process.env.REACT_APP_BUTTON_BORDER_RADIUS,
                backgroundColor: "white",
                boxShadow: process.env.REACT_APP_BUTTON_DEFAULT_SHADOW,
                border: process.env.REACT_APP_BUTTON_TRANSPARENT,
                marginBottom: "20px"
            }} onClick={props.moveToNextContent} btnText={process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_LABEL?? "Tap Here"}/>
        }</div>

    const nextContentContainer = 
        <div style={{
            color: "black", 
            backgroundColor: "white", 
            width: "88%", 
            marginLeft: "auto", 
            marginRight: "auto", 
            marginTop: "20px",
            height: "auto",
            display: "block",
            borderRadius: "8px",
            paddingBottom: "10px"
        }}>
        <div>
            {process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_HIGHTLIGHT_HERO ? <img style={{width: "90%", paddingTop:"20px"}} alt="Next content highlight hero" src={getCdnPath(process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_HIGHTLIGHT_HERO)}/> : <h1 style={{
                color: process.env.REACT_APP_CONTENT_STYLE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_SIZE,
                fontWeight: "600",
                textTransform: "uppercase",
                lineHeight: process.env.REACT_APP_CONTENT_STYLE_TITLE_LINE_HEIGHT,
                textAlign: "center",
                padding: "20px 20px 0px 20px"
            }}>{props.nextContent?.display_name}</h1>}
        </div>
        <div style={{
            borderTop: "#CCC 1px solid",
            width: "85%",
            margin: "0px auto 0px auto",
            textAlign: "left",
            fontWeight : "500",
            lineHeight : "24px",
            fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
            fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
            color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR            
        }}>
            <div style={{marginTop: "20px", marginBottom: "10px"}} dangerouslySetInnerHTML={createMarkup(process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_DESCRIPTION?? props.nextContent?.description)}></div>
            <div>
                {props.moveToNextContent && nextContentButton}
            </div>
        </div>            
    </div>;                


    const loserMessage = 
        <div> 
            <h1 style={{
                color: process.env.REACT_APP_CONTENT_STYLE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_SIZE,
                fontWeight: "600",
                textTransform: "uppercase",
                lineHeight: "28px",
                textAlign: "center",
                paddingTop: "20px"
            }}>Bummer!</h1>
            <div style={{
                borderTop: "#CCC 1px solid",
                width: "85%",
                margin: "0px auto 0px auto",
                textAlign: "center",
                fontWeight : "500",
                lineHeight : "24px",
                paddingBottom: "20px",
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
                fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR                            
            }}>
                <p>Sorry, you didn’t get this one right. Don’t worry, you’ll have another chance to play on the next episode!</p>
                <Button btnText={'WATCH ' + process.env.REACT_APP_NAME_ABBREVIATED + ' ON YOUTUBE'} onClick={() => {
                    // TODO: Track event
                    window.open(process.env.REACT_APP_WHERE_TO_WATCH_URL, '_blank');
                }}/>                
            </div>
            
        </div>;

    useEffect(() => {
        // Track view impression on load
        if(process.env.REACT_APP_NAME === 'Pictionary') {
            setHeroImage(pictAhgHeroImage);
        } else if (process.env.REACT_APP_NAME === '25 Words or Less'){
            setHeroImage(twolAhgHeroImage);
        } else if (process.env.REACT_APP_NAME_ABBREVIATED === 'PPOT') {
            // TO DO: update asset
            setHeroImage(ppotAhgHeroImage);
        }
        updateContentStatus(props.content, 1, device?.deviceDetails, user);
    }, [])

    const exitFullscreenMode = () => {
        if(typeof document !== "undefined" && window.fullscreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { /* Safari */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE11 */
                document.msExitFullscreen();
            }
        }
    }

    const behindTheScenesModule = <BehindTheScenes device={device} content={props.nextContent} user={user} onExitFullscreenMode={()=>exitFullscreenMode()}/>

    return (
        <div>
            {showQuestion ? questionContainer : 
            <div>
                {showLandingPage && <img style={{marginTop: "20px", marginBottom: "20px", display: "none"}} src={thanksARamaGiveAway} alt="30k Thanks-A-Rama Giveaway Logo" />}
                <div style={{paddingTop: "10px", width: "100%", textAlign: "center"}}> 
                    <div style={{
                            color: "black", 
                            backgroundColor: "white", 
                            width: "88%", 
                            marginLeft: "auto", 
                            marginRight: "auto", 
                            height: "auto",
                            display: "block",
                            borderRadius: "20px",
                            paddingBottom: "10px"
                        }}>
                        {showLandingPage && landingPageContainer}
                        {showSubmissionForm && submissionFormContainer}                    
                        {showConfirmation && confirmationContainer}
                        {showLoserMessage && loserMessage}
                    </div>
                    {((showConfirmation || showLoserMessage) && props.nextContent) && behindTheScenesModule}
                    {props.banner}
                    {(showLoserMessage || showConfirmation) && statsModule}
                </div>
            </div>
            }
        </div>
    );
};

export default Sweepstake;
